export const isUndefined = (value) => value === undefined;
export const isNotUndefined = (value) => value !== undefined;
export const isPropertyUndefined = (property) => (value) => value[property] === undefined;
export const isPropertyNotUndefined = (property) => (value) => value[property] !== undefined;
export const arePropertiesUndefined = (...properties) => (value) => properties.every((property) => value[property] === undefined);
export const arePropertiesNotUndefined = (...properties) => (value) => properties.every((property) => value[property] !== undefined);
